import { DatePipe } from '@angular/common';
import {
  Component,
  computed,
  inject,
  model,
  resource,
  ViewEncapsulation,
} from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslocoDirective } from '@jsverse/transloco';
import {
  AvatarComponent,
  ButtonComponent,
  ChevronNext20IconComponent,
  Close20IconComponent,
  DrawerComponent,
  OpenInNew20IconComponent,
  RectangleSkeletonComponent,
  Settings20IconComponent,
  SkeletonContainerComponent,
} from '@zeiss/beyond-online-angular';
import { lastValueFrom } from 'rxjs';
import { HasPermission } from '../../../auth/directives/hasPermission';
import { Permission } from '../../../auth/interfaces/permission.pojo';
import { UserData } from '../../../auth/services/state/user-data';
import { ADMIN_ROUTE_PATHS } from '../../../pages/admin/routing/admin-routes.pojo';
import { ConsultationDataClient } from '../../../pages/consultation/services/apis/consultation/consultation-data-client';
import { ConsultationListResponse } from '../../../pages/consultation/services/apis/consultation/interfaces/consultation.interface';
import { ROUTE_PATHS } from '../../../routing/routes.pojo';

@Component({
  selector: 'app-drawer',
  imports: [
    DrawerComponent,
    ButtonComponent,
    DatePipe,
    Close20IconComponent,
    AvatarComponent,
    TranslocoDirective,
    RouterLink,
    SkeletonContainerComponent,
    RectangleSkeletonComponent,
    Settings20IconComponent,
    ChevronNext20IconComponent,
    OpenInNew20IconComponent,
    HasPermission,
  ],
  templateUrl: './drawer.html',
  styleUrl: './drawer.scss',
  encapsulation: ViewEncapsulation.None,
  host: {
    class: 'drawer',
  },
})
export class Drawer {
  private userService = inject(UserData);
  private http = inject(ConsultationDataClient);

  open = model.required<boolean>();
  public user = this.userService.userData;
  public userFullName = computed(
    () => `${this.user().firstName} ${this.user().lastName}`,
  );

  public readonly CONSULTATION_ROUTE = ROUTE_PATHS.consultation;
  public readonly ADMIN_ROUTE = ADMIN_ROUTE_PATHS.admin;
  protected readonly isAdmin = Permission.ADMIN;

  private lastConsultations: ConsultationListResponse | undefined;

  private consultationRes = resource({
    params: () => ({ isOpen: this.open() }),
    loader: async ({ params }) => {
      if (params.isOpen) {
        const res = await lastValueFrom(this.http.getConsultations());
        this.lastConsultations = res;
        return res;
      }
      return this.lastConsultations;
    },
  });

  public consultationResponse = this.consultationRes.value;
  public isLoading = this.consultationRes.isLoading;

  public closeDrawer() {
    this.open.set(false);
  }

  public logout() {
    this.userService.logout();
  }
}
